import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { buildStore } from '@shared/store/createStore';
import ErrorModal from '../containers/modals/errorModal';
import { render } from 'react-dom';
import { getWindow } from '../services/window';
import combineReducers from '../reducers/reducers';
import { isEmbedded } from '../utils/appUtils';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import classNames from 'classnames';
export function renderErrorModal(store, isEmbed = false) {
    if (!store) {
        const initialState = window.__INITIAL_STATE__;
        store = buildStore({
            combinedReducers: combineReducers,
            initialState,
            middleware: [
                thunk
            ]
        });
        isEmbed = initialState.config.isEmbedded;
    }
    const modalBackgroundClasses = classNames({
        spza_presentation: true,
        spza_background_1: true,
        spza_background_2: false
    });
    const modalClasses = classNames({
        spza_dialog: true,
        spza_dialog_design2: false
    });
    let dismissModal = null;
    if (!isEmbed) {
        dismissModal = ()=>{
            const href = getWindow().location.origin + '/home';
            getWindow().location.assign(href);
        };
    } else {
        dismissModal = ()=>{
            getWindow().parent.postMessage({
                msgType: 'closeSaasMarketplace'
            }, '*');
        };
    }
    render(/*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames({
                spza_root: !isEmbedded(),
                spza_root_embedded: isEmbedded()
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: modalClasses,
                children: /*#__PURE__*/ _jsx("div", {
                    className: modalBackgroundClasses,
                    children: /*#__PURE__*/ _jsx(ErrorModal, {
                        dismissModal: dismissModal
                    })
                })
            })
        })
    }), document.getElementById('react-view'));
}
